import React from 'react';
import { Chip } from "@mui/material";

/**
 * A standardized active filter pill component.
 * Used across Task, Project, and Group pages for consistent UI.
 */
const ActiveFilterPill = ({ label, onDelete, sx = {} }) => {
  return (
    <Chip
      label={label}
      size="small"
      onDelete={onDelete}
      sx={{
        borderRadius: "20px",
        fontSize: "0.75rem",
        fontWeight: 500,
        backgroundColor: "#d32f2f",
        color: "#fff",
        border: "1px solid #d32f2f",
        boxShadow: "0 2px 6px rgba(211, 47, 47, 0.3)",
        "& .MuiChip-deleteIcon": {
          color: "rgba(255, 255, 255, 0.8)",
          fontSize: "16px",
          "&:hover": { color: "#fff" },
        },
        "& .MuiChip-label": {
          px: 1.5,
        },
        ...sx,
      }}
    />
  );
};

export default ActiveFilterPill;
